import React from "react";
import { Link, Outlet } from "react-router-dom";
const MainLayoutDW = () => {
  return (
    <div className={`wrapper`} id="header">
      <header className={"header _watcher-view"}>
        <div className="header__container">
          <div className="header__body_dw">
            <Link to="/" className="header__logo">
              <img src="/img/logo.png" alt="logo Scout" />
            </Link>
          </div>
        </div>
      </header>
      <main style={{ height: "100svh" }}>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayoutDW;
